// 

$(document).ready(function(){
    $('.faq-holder').click(function(){
        // Toggle the class 'ahtisham' on the clicked .faq-holder
        $(this).toggleClass('show-accordian');
        
        // Check if the clicked .faq-holder now has the class 'ahtisham'
        if ($(this).hasClass('show-accordian')) {
            // If it does, remove the class 'ahtisham' from all other .faq-holder elements
            $('.faq-holder').not(this).removeClass('show-accordian');
        }
    });
});

// ==================home-product-slider===================

$('.owl-carousel.index-corporate-merchandise').owlCarousel({
    loop:false,
    margin:25,
    navText: ["<i class='fa-solid fa-arrow-left' style='color: #004BAA;'></i>" , "<i class='fa-solid fa-arrow-right' style='color: #004BAA;'></i> "],
    nav:true,
    dots:false,
    responsive:{
        0:{
            items:1
        },
        600:{
            items:2,
            margin:15,
        },
        1000:{
            items:3
        }
    }
});

$('.owl-carousel.trending-news').owlCarousel({
    loop:true,
    margin:40,
    nav:false,
    dots:false,
    responsive:{
        0:{
            items:1
        },
        600:{
            items:1.4
        },
        1000:{
            items:2.4
        }
    }
})

document.getElementById("cvsbtn").addEventListener("click", () => {
    Fancybox.show([
      {
        src: "https://cdn.shopify.com/videos/c/o/v/791588a78a5d417f851efd45cdc9756a.mp4"
      }
    ]);
  });  